import { http } from './config'

export default {
  listar:() => {
    return http.get(`cardapio.php?`)
  },  
  listarQtd:(cd) => {
    return http.get('cardapio_qtd.php?cd='+cd)
  },  
  alteraQtd:(estoque) => {
    
    return http.put('cardapio_qtd_alterar.php',(estoque))
  }  
}